import { EventRegistryCategory } from '../../EventRegistryCategory';
import { EventRegistryItem } from '../../EventRegistryItem';
export class EventRegistryReactTransition extends EventRegistryCategory {
    label = 'Transition Events';
    constructor(parent) {
        super(parent);
        super.init();
    }
    transitionend = () => new EventRegistryItem({ handlerName: 'onTransitionEnd' });
}
